/** The current host contract version, sent in `X-Imagora-Contract`. Incompatible changes get a new version and 90 days of overlap. */
export const CONTRACT_VERSION = "1";
export const SUPPORTED_CONTRACT_VERSIONS: ReadonlyArray<string> = [CONTRACT_VERSION];
export const CONTRACT_HEADER = "X-Imagora-Contract";
/** How a host key, or an agency user, addresses a tenant: an Imagora id or `ref:<hostRef>`. */
export const TENANT_HEADER = "X-Imagora-Tenant";

/** Paths that take no bearer token. The auth middleware and the API document both read this. */
export const PUBLIC_API_PATHS: ReadonlyArray<RegExp> = [/^\/v1\/public(\/|$)/, /^\/v1\/webhooks(\/|$)/, /^\/v1\/sso\/exchange$/, /^\/v1\/openapi\.json$/, /^\/v1\/docs$/];
